module.exports = __webpack_public_path__ + "img/b6acaf3.png";